module.exports = __webpack_public_path__ + "img/style_title.129b67f0.png";